(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "../constants", "../events/embedded/events", "./types", "../utils/IterableActionRunner"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("../constants"), require("../events/embedded/events"), require("./types"), require("../utils/IterableActionRunner"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.constants, global.events, global.types, global.IterableActionRunner);
    global.utils = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _constants, _events, _types, _IterableActionRunner) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.addButtonClickEvent = void 0;
  _exports.getTrimmedText = getTrimmedText;
  _exports.handleEmbeddedClick = _exports.handleElementClick = _exports.handleButtonClick = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-use-before-define */
  function getTargetUrl(action) {
    if (!action) return '';
    if (action.type === _constants.URL_SCHEME_OPEN) {
      return (action === null || action === void 0 ? void 0 : action.data) || '';
    }
    return action.type;
  }
  var handleElementClick = _exports.handleElementClick = function handleElementClick(message, appPackageName, errorCallback) {
    var _message$elements;
    var targetUrl = getTargetUrl(message === null || message === void 0 ? void 0 : (_message$elements = message.elements) === null || _message$elements === void 0 ? void 0 : _message$elements.defaultAction);
    handleEmbeddedClick(targetUrl);
    (0, _events.trackEmbeddedClick)({
      messageId: message.metadata.messageId,
      buttonIdentifier: '',
      targetUrl: targetUrl,
      appPackageName: appPackageName
    })["catch"](function (error) {
      if (errorCallback) {
        var _error$response, _error$response2;
        errorCallback(_objectSpread(_objectSpread({}, error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data), {}, {
          statusCode: error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status
        }));
      }
    });
  };
  var handleButtonClick = _exports.handleButtonClick = function handleButtonClick(button, message, appPackageName, errorCallback) {
    var targetUrl = getTargetUrl(button === null || button === void 0 ? void 0 : button.action);
    handleEmbeddedClick(targetUrl);
    (0, _events.trackEmbeddedClick)({
      messageId: message.metadata.messageId,
      buttonIdentifier: (button === null || button === void 0 ? void 0 : button.id) || '',
      targetUrl: targetUrl,
      appPackageName: appPackageName
    })["catch"](function (error) {
      if (errorCallback) {
        var _error$response3, _error$response4;
        errorCallback(_objectSpread(_objectSpread({}, error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data), {}, {
          statusCode: error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status
        }));
      }
    });
  };
  var addButtonClickEvent = _exports.addButtonClickEvent = function addButtonClickEvent(button, index, message, appPackageName, errorCallback) {
    button.addEventListener('click', function (event) {
      var _message$elements2;
      // Prevent the click event from bubbling up to the div
      event.stopPropagation();
      if (message !== null && message !== void 0 && (_message$elements2 = message.elements) !== null && _message$elements2 !== void 0 && _message$elements2.buttons) {
        var _message$elements3;
        handleButtonClick(message === null || message === void 0 ? void 0 : (_message$elements3 = message.elements) === null || _message$elements3 === void 0 ? void 0 : _message$elements3.buttons[index], message, appPackageName, errorCallback);
      }
    });
  };
  var handleEmbeddedClick = _exports.handleEmbeddedClick = function handleEmbeddedClick(clickedUrl) {
    if (clickedUrl && clickedUrl.trim() !== '') {
      var actionType;
      var actionName;
      if (clickedUrl.startsWith(_constants.URL_SCHEME_ACTION)) {
        actionName = '';
        actionType = clickedUrl;
      } else if (clickedUrl.startsWith(_constants.URL_SCHEME_ITBL)) {
        actionName = '';
        actionType = clickedUrl.replace(_constants.URL_SCHEME_ITBL, '');
      } else {
        actionType = _constants.URL_SCHEME_OPEN;
        actionName = clickedUrl;
      }
      var iterableAction = {
        type: actionType,
        data: actionName
      };
      _IterableActionRunner.IterableActionRunner.executeAction(null, iterableAction, _types.IterableActionSource.EMBEDDED);
    }
  };
  function getTrimmedText(text) {
    var unsafeText = text && typeof text === 'string' ? text.trim() : '';
    return escapeHtml(unsafeText);
  }
  function escapeHtml(unsafe) {
    return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
});